import { cn } from "@/lib/utils/utils";

export function DigModeIcon({ className, isActive }: { className?: string; isActive?: boolean }) {
    return (
        <svg
            className={cn("transition-all duration-300", className)}
            width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        >
            {/* Top Layer (Modern Context) - Solid and Primary when active */}
            <path
                d="M12 2 2 7l10 5 10-5-10-5Z"
                className={cn("transition-all duration-300", isActive ? 'stroke-primary fill-primary/20 stroke-[2.5]' : 'opacity-100')}
            />

            {/* Middle Layer (Biblical Context) */}
            <path
                d="m2 12 10 5 10-5"
                className={cn("transition-all duration-300", isActive ? 'stroke-primary/70 stroke-[2]' : 'opacity-70')}
            />

            {/* Bottom Layer (Ancient Context) */}
            <path
                d="m2 17 10 5 10-5"
                className={cn("transition-all duration-300", isActive ? 'stroke-primary/40 stroke-[2]' : 'opacity-40')}
            />
        </svg>
    );
}
